
namespace GeniuzPOS.Product {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class SkuHdDialog extends Serenity.EntityDialog<SkuHdRow, any> {
        protected getFormKey() { return SkuHdForm.formKey; }
        protected getIdProperty() { return SkuHdRow.idProperty; }
        protected getLocalTextPrefix() { return SkuHdRow.localTextPrefix; }
        protected getNameProperty() { return SkuHdRow.nameProperty; }
        protected getService() { return SkuHdService.baseUrl; }
        protected getDeletePermission() { return SkuHdRow.deletePermission; }
        protected getInsertPermission() { return SkuHdRow.insertPermission; }
        protected getUpdatePermission() { return SkuHdRow.updatePermission; }

        protected form = new SkuHdForm(this.idPrefix);
        constructor() {
            super();

            this.form = new SkuHdForm(this.idPrefix);
            (this.form.PluDtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
            });
            this.form.VatType.element.parent();
            this.form.VatType.change(e => {
                var isVatTypeN = this.VatTypeN;
                var isVatTypeV = this.VatTypeV;


                if (!isVatTypeN) {
                    Serenity.EditorUtils.setReadOnly(this.form.VatCode, !isVatTypeN);
                    return this.form.VatCode.value = "N";

                }
                else if (!isVatTypeV) {
                    Serenity.EditorUtils.setReadOnly(this.form.VatCode, isVatTypeV);
                    return this.form.VatCode.value = "V7";

                }
            });

            this.form.VatCode.change(e => {
                var vat = Q.toId(this.form.VatType.value);
                var vatv = Q.toId(this.form.VatCode.value);

                if (vat == 'V') {
                    if (vatv == 'N') {
                        return this.form.VatCode.value = "V0";
                    }
                }

            });

            this.form.PurVatType.change(e => {
                var isPurVatTypeN = this.PurVatTypeN;
                var isPurVatTypeV = this.PurVatTypeV;


                if (!isPurVatTypeN) {
                    Serenity.EditorUtils.setReadOnly(this.form.PurVatCode, !isPurVatTypeN);
                    return this.form.PurVatCode.value = "N";

                }
                else if (!isPurVatTypeV) {
                    Serenity.EditorUtils.setReadOnly(this.form.PurVatCode, isPurVatTypeV);
                    return this.form.PurVatCode.value = "V7";

                }
            });

            this.form.ActiveFg.change(e => {

                this.ActiveFgT();
            });

            this.form.PurVatCode.change(e => {
                var vat = Q.toId(this.form.PurVatType.value);
                var vatv = Q.toId(this.form.PurVatCode.value);

                if (vat == 'V') {
                    if (vatv == 'N') {
                        return this.form.PurVatCode.value = "V0";
                    }
                }

            });



            this.form.StockFg.element.parent();
            this.form.StockFg.change(e => {
                var isStockFgT = this.StockFgT;
                var isStockFgF = this.StockFgF;


                if (!isStockFgT) {
                    Serenity.EditorUtils.setReadOnly(this.form.StkUnit, isStockFgT);
                    Serenity.EditorUtils.setReadOnly(this.form.MinStockQty, isStockFgT);
                    Serenity.EditorUtils.setReadOnly(this.form.MaxStockQty, isStockFgT);
                    Serenity.EditorUtils.setReadOnly(this.form.SetItemFg, isStockFgT);
                    this.form.StkUnit.element.toggleClass("required", true);
                    this.form.PurUnit.element.toggleClass("required", true);

                    // return this.form.StkUnit.value = "";
                    // return this.form.MinStockQty.value = 0;
                    // return this.form.MaxStockQty.value = 0;
                }
                else if (!isStockFgF) {
                    Serenity.EditorUtils.setReadOnly(this.form.StkUnit, !isStockFgF);
                    Serenity.EditorUtils.setReadOnly(this.form.MinStockQty, !isStockFgF);
                    Serenity.EditorUtils.setReadOnly(this.form.MaxStockQty, !isStockFgF);
                    Serenity.EditorUtils.setReadOnly(this.form.SetItemFg, !isStockFgF);
                    this.form.StkUnit.element.toggleClass("required", false);
                    this.form.PurUnit.element.toggleClass("required", false);

                    this.form.MinStockQty.value = 0,
                        this.form.MaxStockQty.value = 0,
                        this.form.SetItemFg.value = false;




                }
            });
            this.form.ConsignFg.element.parent();

            this.form.ConsignFg.change(e => {
                var isConsignFgT = this.ConsignFgT;
                var isConsignFgF = this.ConsignFgF;


                if (!isConsignFgT) {
                    Serenity.EditorUtils.setReadOnly(this.form.ConsignGp, isConsignFgT);
                    Serenity.EditorUtils.setReadOnly(this.form.CusProductTypeNbp, isConsignFgT);
                    this.form.CusProductTypeNbp.element.toggleClass("required", true);

                    // return this.form.ConsignGp.value = 0;

                }
                else if (!isConsignFgF) {
                    Serenity.EditorUtils.setReadOnly(this.form.ConsignGp, !isConsignFgF);
                    Serenity.EditorUtils.setReadOnly(this.form.CusProductTypeNbp, !isConsignFgF);
                    this.form.CusProductTypeNbp.element.toggleClass("required", false);
                    this.form.CusProductTypeNbp.value = null;
                    this.form.ConsignGp.value = 0;

                }
            });
        }


        private get VatTypeN() {
            return this.form.VatType.value != "N";
        }
        private get VatTypeV() {
            return this.form.VatType.value != "V";
        }
        private get PurVatTypeN() {
            return this.form.PurVatType.value != "N";
        }
        private get PurVatTypeV() {
            return this.form.PurVatType.value != "V";
        }
        private get StockFgT() {
            return this.form.StockFg.value != true;
        }
        private get StockFgF() {
            return this.form.StockFg.value != false;
        }
        private get ConsignFgT() {
            return this.form.ConsignFg.value != true;
        }
        private get ConsignFgF() {
            return this.form.ConsignFg.value != false;
        }

        private ActiveFgT() {
            var a = this.form.ActiveFg.value;

                console.log(a)

                if (a == true) {
                    Serenity.EditorUtils.setReadOnly(this.form.ActivePurFg, false);
                    Serenity.EditorUtils.setReadOnly(this.form.ActiveSellFg, false);
                    return this.form.ActivePurFg.value = true;
                    return this.form.ActiveSellFg.value = true;
                    

                }
                else {
                    Serenity.EditorUtils.setReadOnly(this.form.ActivePurFg, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ActiveSellFg, true);
                    return this.form.ActivePurFg.value = false;
                    return this.form.ActiveSellFg.value = false;

                }
        }

        protected updateInterface() {
            super.updateInterface();
            if (!this.isNew()) {
                if (this.entity.SkuCode) {
                    if (this.form.SkuCode.element.attr("readonly")) {
                        // Serenity.EditorUtils.setReadonly(this.form.MarketDate.element, true);
                        Serenity.EditorUtils.setReadonly(this.form.QtyOnhand.element, true);
                        // Serenity.EditorUtils.setReadonly(this.form.VatType.element, true);
                        // Serenity.EditorUtils.setReadonly(this.form.VatCode.element, true);
                        Serenity.EditorUtils.setReadonly(this.form.StockFg.element, true);
                        // Serenity.EditorUtils.setReadonly(this.form.SetItemFg.element, true);
                        // Serenity.EditorUtils.setReadonly(this.form.ConsignFg.element, true);
                        // Serenity.EditorUtils.setReadonly(this.form.ConsignGp.element, true);
                        Serenity.EditorUtils.setReadonly(this.form.StkUnit.element, true);
                        // Serenity.EditorUtils.setReadonly(this.form.PurUnitPrice.element, true);


                        //StockCostValue VatType
                    }
                    // Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                    // this.element.find('sup').hide();
                    // this.deleteButton.hide();


                }


            }
        }
        protected initToolbar() {
            super.initToolbar();

        }
        protected onDialogOpen() {
            super.onDialogOpen()
            if (this.form.StockFg.value == true) {
                this.form.StkUnit.element.toggleClass("required", true);
                this.form.PurUnit.element.toggleClass("required", true);
            }
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            // let newDeleteBtn: Serenity.ToolButton =
            //     {
            //         title: "ลบเอกสาร'",
            //         hint: "Delete",
            //         separator: false,
            //         cssClass: "delete-button",
            //         icon: "fa fa-save",
            //         hotkey: 'alt+x',
            //         onClick: (e) => {
            //             Q.confirm('ยืนยันการลบเอกสาร', () => {
            //                 this.doDelete(() => {
            //                     this.dialogClose();
            //                 });
            //             });
            //         }
            //     };
            //     buttons.push(newDeleteBtn);

            let gen: Serenity.ToolButton =
            {
                title: "Gen.SkuCode",
                hint: "Gennarate SkuCode (Gen to 13 digit)",
                separator: false,
                cssClass: "button-gen",
                icon: "fa fa-magic",
                //hotkey: 'alt+s',
                onClick: (e) => {
                    var self = this;


                    var s = self.form.SkuCode.value
                    if (s.length <= 0) {
                        s = Q.formatDate(new Date(), "ddMMyy")
                    }
                    GeniuzPOS.Product.CsSkuService.GetNextNumber({
                        Prefix: s,
                        Length: 13
                    }, response => {

                        self.form.SkuCode.value = response.Serial;

                    });

                }
            };
            buttons.push(gen);

            let gene: Serenity.ToolButton =
            {
                title: "Gen.EAN13",
                hint: "Gennarate SkuCode (Gen to 13 digit)",
                separator: false,
                cssClass: "button-gen",
                icon: "fa fa-magic",
                //hotkey: 'alt+s',
                onClick: (e) => {
                    var self = this;


                    var s = self.form.SkuCode.value
                    if (s.length <= 0) {
                        s = Q.formatDate(new Date(), "ddMMyy")
                    }
                    GeniuzPOS.Product.CsSkuService.GetNextNumberEAN({
                        Prefix: s,
                        Length: 13
                    }, response => {

                        self.form.SkuCode.value = response.Serial;

                    });

                }
            };
            buttons.push(gene);


            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }
        protected beforeLoadEntity() {
            let self = this;
            self.toolbar.findButton('save-and-close-button').text('บันทึกสินค้า');
            self.toolbar.findButton('delete-button').text('ลบสินค้า');



            //----
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {


                    if ((self as any).isMarkedAsPanel === true) {

                        if (self.element.find(".panel-titlebar").length == 1) {

                            if (self.isNew() == true) {
                                self.element.find(".panel-titlebar-text").html(self.element.find(".panel-titlebar-text").html().replace("New", "สร้าง"));

                            } else {
                                self.element.find(".panel-titlebar-text").html(self.element.find(".panel-titlebar-text").html().replace("Edit", "แก้ไข"));
                            }
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                            // self.element.parent().find(".panel-titlebar").html("");
                            if (self.isNew() == true) {
                                self.element.parent().find(".panel-titlebar-text").html(self.element.parent().find(".panel-titlebar-text").html().replace("New", "สร้าง"));

                            } else {
                                self.element.parent().find(".panel-titlebar-text").html(self.element.parent().find(".panel-titlebar-text").html().replace("Edit", "แก้ไข"));
                            }

                            self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();

        }
        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.form.PluDtList.myPassValue = this.entity.SkuCode
            this.form.PluDtList.myPassValue1 = this.entity.SkuDesc
            this.form.PluDtList.myPassValue2 = this.entity.StyleId
            this.form.PluDtList.myPassValue3 = this.entity.ColorId
            this.form.PluDtList.myPassValue4 = this.entity.MatTypeId
            this.form.PluDtList.myPassValue5 = this.entity.SizeId
            this.form.PluDtList.myPassValue6 = this.entity.TasteId
            this.form.PluDtList.myPassValue7 = this.entity.StkUnit
            this.form.PluDtList.myPassValue8 = this.entity.ConceptCode
            this.syscuscheck();

            if (this.isNew()) {
                // this.toolbar.findButton("button-gen").hide(); //เปิดฟังชั่นเจน ดรอปบรรทัดนี้

            } else {
                this.toolbar.findButton("button-gen").hide();
                this.ActiveFgT();
            }

            var purchase = Q.tryFirst(CsPluRow.getLookup().items, x => x.SkuCode == this.entity.SkuCode);
            if (purchase != null) {
                this.deleteButton.toggleClass('disabled', true);
            }

            var Plucheck = Q.tryFirst(Inventory.IcStockTranRow.getLookup().items, x => x.SkuCode == this.entity.SkuCode);
            if (Plucheck != null) {
                this.deleteButton.toggleClass('disabled', true);
            }
            var pr = Q.tryFirst(Purchase.PoPurRequestDtRow.getLookup().items, x => x.SkuCode == this.entity.SkuCode);
            if (pr != null) {
                this.deleteButton.toggleClass('disabled', true);
            }
            var po = Q.tryFirst(Purchase.PoPurOrderDtRow.getLookup().items, x => x.SkuCode == this.entity.SkuCode);
            if (po != null) {
                this.deleteButton.toggleClass('disabled', true);
            }
            var pi = Q.tryFirst(Purchase.PoPurInvoiceDtRow.getLookup().items, x => x.SkuCode == this.entity.SkuCode);
            if (ir != null) {
                this.deleteButton.toggleClass('disabled', true);
            }
            var ir = Q.tryFirst(Purchase.PoInvoiceReceiveDtRow.getLookup().items, x => x.SkuCode == this.entity.SkuCode);
            if (ir != null) {
                this.deleteButton.toggleClass('disabled', true);
            }
            var cn = Q.tryFirst(Purchase.PoCreditNoteDtRow.getLookup().items, x => x.SkuCode == this.entity.SkuCode);
            if (cn != null) {
                this.deleteButton.toggleClass('disabled', true);
            }

        }

        protected getSaveEntity(): SkuHdRow {
            let entity = super.getSaveEntity();

            return entity;
        }

        private syscuscheck() {
            // let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 52 && x.SysFg > 0)
            // console.log(app)
            // if (app != null) {
            //     // this.form.CusProductSalesBeforeFlag.getGridField().toggle(true);
            //     // this.form.CusProductSalesBeforeReferFlag.getGridField().toggle(true);
            //     this.form.CusProductSalesBeforeRefer.getGridField().toggle(true);
            // } else {
            //     // this.form.CusProductSalesBeforeFlag.getGridField().toggle(false);
            //     // this.form.CusProductSalesBeforeReferFlag.getGridField().toggle(false);
            //     this.form.CusProductSalesBeforeRefer.getGridField().toggle(false);
            // }

            let non = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 51 && x.SysFg > 0)
            // console.log(vatfg)
            if (non != null) {
                this.form.NonAllowtoDiscountFg.getGridField().toggle(true);
            } else {
                this.form.NonAllowtoDiscountFg.getGridField().toggle(false);
            }
            let main = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 50 && x.SysFg > 0)
            // console.log(vatfg)
            if (main != null) {
                this.form.SupplItemCode.getGridField().toggle(true);
            } else {
                this.form.SupplItemCode.getGridField().toggle(false);
            }
            let local = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 76 && x.SysFg > 0)
            // console.log(vatfg)
            if (local != null) {
                this.form.CusImportOrLocal.getGridField().toggle(true);
            } else {
                this.form.CusImportOrLocal.getGridField().toggle(false);
            }

            let por = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 49 && x.SysFg > 0)
            // console.log(vatfg)
            if (por != null) {
                this.form.ProductCpComponent.getGridField().toggle(true);
                this.form.ProductCpDesc1.getGridField().toggle(true);
                this.form.ProductCpDesc2.getGridField().toggle(true);
                this.form.ProductCpHowToUse.getGridField().toggle(true);
                this.form.ProductCpWarning.getGridField().toggle(true);
            } else {
                this.form.ProductCpComponent.getGridField().toggle(false);
                this.form.ProductCpDesc1.getGridField().toggle(false);
                this.form.ProductCpDesc2.getGridField().toggle(false);
                this.form.ProductCpHowToUse.getGridField().toggle(false);
                this.form.ProductCpWarning.getGridField().toggle(false);
            }


        }


    }
}